module.exports = __webpack_public_path__ + "img/chevron_right_white.04d966fb.svg";